module.exports = __webpack_public_path__ + "static/media/personalization-present-banner.c69402af.png";